import Limpiezadron from "../../../components/servicios/limpiezadron/limpiezadron";
import { IoIosArrowForward } from "react-icons/io";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";




export default function Limpieza() {

  return (
    <>
     <Helmet>
        <title>Axinntus | Limpieza de Superficies y Estructuras industriales con dron.</title>
        <meta
          name="description"
          content="Axinntus en conjunto con KTV Working Drone, empresa Noruega con 30 años de experiencia en limpieza de fachadas, ofrecen un servicio que se puede adaptar a cualquier lugar y estructura, brindando una operación segura y con altos estándares de excelencia operacional."
        />
        <meta
          name="keywords"
          content="Axinntus, mantenimientos industriales, operación industriales, equipos multiculturalidad, equipos de excelencia, trabajar en Axinntus, personas, seguridad, activos."
        />
      </Helmet>
      <Container maxWidth="xl" sx={{marginTop:'-40px','@media (max-width: 960px)':{
                marginTop:'0px'
              },}} >
        <div
          className="paginacompleta"

        >
          <div
            style={{ display: "flex", alignItems: "center", fontSize: "0.8rem" }}
          >
            {" "}
            <p style={{ fontWeight: "400", color: "#898b8a" }}>
              {" "}
              Nuestros servicios
            </p>{" "}
            <IoIosArrowForward
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                color: "#6f7170",
              }}
            />{" "}
            <strong style={{ color: "#6f7170" }}>

            Limpieza de Superficies y Estructuras industriales con dron</strong>
          </div>
        </div>
      </Container>
      <Limpiezadron />
    </>
  )
}